import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/ui/primitives'

export type SignOutConfirmModalProps = {
  open: boolean
  onCancel: () => void
  onConfirm: () => void
}

export function SignOutConfirmModal({ open, onCancel, onConfirm }: SignOutConfirmModalProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onCancel()
      }}
    >
      <DialogContent data-testid="register-sign-out-modal">
        <DialogHeader>
          <DialogTitle>Leave registration?</DialogTitle>
          <DialogDescription>
            You&apos;ll be signed out and your progress will be cleared. You can always come back
            and start again.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onCancel}>
            Stay
          </Button>
          <Button
            type="button"
            variant="destructive"
            onClick={onConfirm}
            data-testid="register-sign-out-confirm"
          >
            Sign out
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
